const defaultFeatures = (window && window.defaultFeatures) || {};
const featuresOverride = (window && window.features) || {};
const features = { ...defaultFeatures, ...featuresOverride };

export const FOUNDATION = !!features.foundation;

export default features;
